module.exports = __webpack_public_path__ + "static/media/chester-wade.e2cb884f.jpg";